/* Comutatoare „Recomandate pentru tine” din coșul lateral (snippets/werstil-cart-extras.liquid) */
(function () {
  var busy = false;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function post(url, body) {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }

  function refresh(state) {
    var d = drawer();
    if (d && state && state.sections && typeof d.renderContents === 'function') d.renderContents(state);
    else window.location.reload();
  }

  // Capture + stopPropagation: altfel evenimentul ajunge la <cart-drawer-items> al temei,
  // care îl tratează ca pe o schimbare de cantitate (eroare în cart.js)
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.werstil-upsells__input');
    if (!input) return;
    e.stopPropagation();
    if (busy) { input.checked = !input.checked; return; }
    busy = true;
    var box = input.closest('[data-werstil-upsells]');
    if (box) box.classList.add('is-loading');

    var req = input.checked
      ? post(window.routes.cart_add_url + '.js', { items: [{ id: Number(input.dataset.variantId), quantity: 1 }] })
      : post(window.routes.cart_change_url, { id: input.dataset.lineKey, quantity: 0 });

    req.then(refresh).catch(function (err) {
      input.checked = !input.checked;
      if (box) box.classList.remove('is-loading');
      alert((err && (err.description || err.message)) || 'Nu am putut actualiza coșul. Încearcă din nou.');
    }).finally(function () {
      busy = false;
    });
  }, true);

  // Dacă în coș au rămas doar servicii (fără produse reale), le scoatem automat
  function cleanup() {
    var box = document.querySelector('[data-werstil-upsells]');
    if (!box || busy || box.dataset.realItems !== '0') return;
    var updates = {};
    box.querySelectorAll('.werstil-upsells__input:checked').forEach(function (i) {
      if (i.dataset.lineKey) updates[i.dataset.lineKey] = 0;
    });
    if (!Object.keys(updates).length) return;
    busy = true;
    post(window.routes.cart_update_url, { updates: updates }).then(refresh).catch(function () {}).finally(function () {
      busy = false;
    });
  }

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(cleanup, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', cleanup);
})();
